import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useScrollSelector } from '@gluedigital/scrollastic'
import MarkdownMessage from '@gluedigital/markdown-message'
import './Clients.sass'

const Clients = () => {
  const activeClass = useScrollSelector('.section', { boundary: '35vh', fromBottom: true })

  const clients = ['carrefour', 'kfc', 'axa', 'ebay', 'mondelez', 'atandt']
  const clientsLogos = clients.map((client, i) => {
    const url = `/images/clients/${client}-logo.png`
    const style = { backgroundImage: 'url("' + url + '")' }
    return <div key={i} className="logo" id={client} style={style} />
  })
  return (
    <section className={`section ${activeClass || ''}`} id="clients">
      <div className="container">
        <div className="split">
          <div className="item left">
            <div className="clients-card">
              <h1>
                <MarkdownMessage id="home.clients.title" />
              </h1>
              <p>
                <FormattedMessage id="home.clients.text" />
              </p>
            </div>
          </div>
          <div className="item right">
            <div className="clients-card">
              {clientsLogos}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Clients
